import {useState} from "react";
import className from "classnames/bind";
import FontAwesomeIcon from "../FontAwesome";
import Loading from "../Loading";
import style from "./SearchBar.module.scss";

const cn = className.bind(style);

/**
 * Thanh công cụ hợp nhất: icon + input + nút LIỀN KHỐI trong 1 khung bo tròn, cùng
 * chiều cao → canh đều tuyệt đối. Dùng cho các form nhập nhanh (domain/url…).
 *
 * Props:
 *  - icon         : class FontAwesome đầu thanh (mặc định globe).
 *  - placeholder  : gợi ý input.
 *  - buttonText   : chữ trên nút (mặc định "Kiểm tra").
 *  - buttonIcon   : class FontAwesome trên nút.
 *  - loading      : trạng thái đang xử lý (khoá input + spinner).
 *  - onSubmit(v)  : gọi khi submit với giá trị đã trim (không rỗng).
 *  - defaultValue : giá trị khởi tạo.
 *  - error        : chuỗi lỗi hiển thị dưới thanh (tuỳ chọn).
 */
function SearchBar({
	icon = "fa-light fa-globe",
	placeholder = "",
	buttonText = "Kiểm tra",
	buttonIcon = "fa-light fa-magnifying-glass",
	loading = false,
	onSubmit,
	defaultValue = "",
	error,
}) {
	const [value, setValue] = useState(defaultValue);
	const [touched, setTouched] = useState(false);

	const submit = (e) => {
		e.preventDefault();
		if (loading) return;
		const v = value.trim();
		setTouched(true);
		if (!v) return;
		onSubmit?.(v);
	};

	const showError = error || (touched && !value.trim() ? "Vui lòng nhập nội dung" : "");

	return (
		<div className={cn('wrap')}>
			<form className={cn('bar', {invalid: !!showError})} onSubmit={submit}>
				<span className={cn('lead')}>
					<FontAwesomeIcon icon={icon} />
				</span>
				<input
					className={cn('input')}
					value={value}
					placeholder={placeholder}
					disabled={loading}
					onChange={(e) => setValue(e.target.value)}
				/>
				<button type="submit" className={cn('btn')} disabled={loading}>
					{loading
						? <Loading noFixed spin className={cn('spin')} />
						: <FontAwesomeIcon icon={buttonIcon} />}
					<span>{buttonText}</span>
				</button>
			</form>
			{showError && <p className={cn('error')}>{showError}</p>}
		</div>
	);
}

export default SearchBar;
